import { NgModule } from '@angular/core';

import {
  DeleteTemplateCommandServiceModule,
  DeleteTemplateCommandComponentModule
} from '.';

@NgModule({
  imports: [
    DeleteTemplateCommandServiceModule,
    DeleteTemplateCommandComponentModule
  ],
  exports: [
    DeleteTemplateCommandServiceModule,
    DeleteTemplateCommandComponentModule
  ]
})
export class DeleteTemplateCommandModule { }
